import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { TripStepTypes } from '../../lib/types/models/trip-booking/trip-step'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getTripSteps(
  input: PaginationRequest<TripStepTypes.Filter> & { tripBookingId: number }
) {
  const { tripBookingId, ...rest } = input
  return restApiClient
    .url(
      encodeNestedObject<PaginationRequest<TripStepTypes.Filter>>(
        constructApiUrl(API['trip-bookings'].getTripSteps.url, { id: tripBookingId }),
        rest
      )
    )
    .get<PaginationResponse<TripStepTypes.Full>>()
}
